import { atom } from 'recoil';
import { PaymentType } from '~/types';

const paymentType = atom<PaymentType>({
  key: 'paymentType',
  default: PaymentType.NONE,
});

export default paymentType;
